import { EventBus } from "~/code/event-bus";

export function useErrorHandler() {
  function handleErrors(response: any, contextMessage: string = "Error") {
    let errors = Array.isArray(response)
      ? response
      : Array.isArray(response?.errors)
      ? response.errors
      : null;

    if (!errors || errors.length === 0) return;

    const list = errors
      .map((err: any) => `• ${err.message || err.code || "Unknown error"}`)
      .join("\n");

    EventBus.emit("toast", {
      type: "error",
      message: `${contextMessage}:\n${list}`,
    });

    return errors;
  }

  return { handleErrors };
}
